import type { FaireProductEntity } from "../../entity_types/product";

export const p_drd6wqqxts: FaireProductEntity = {
  token: "p_drd6wqqxts",
  type: "product",
  name: "Youth Size Mossy Oak - #64111 - Camo Velcro Enclosure Adjust",
  brandToken: "b_c5the2m9ad",
  brandName: "St. Louis Wholesale LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/6e87fdfce019b048ef5341981596e30d07a0ce64a61c331e4982ee585003b4b5.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    "Youth Size Mossy Oak - #64111 - Camo Velcro Enclosure Adjustable - The Logo",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:49.772Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
